<template lang="pug">
.color-preview.color-preview-input(v-if="hexadecimal" :style="hexadecimal ? `border-color:#${hexadecimal}` : ''")
</template>

<script>
export default {
  name: 'Color',

  props: {
    hexadecimal: String
  }
}
</script>

<style lang="stylus">
.color-preview-input
  position absolute
  right 1.25em
  top 1.13em
  margin 0
</style>



// WEBPACK FOOTER //
// src/components/elements/Color.vue